import { useState, useEffect, useMemo, useCallback } from "react";
import { Routes, Route, Navigate, Outlet, BrowserRouter, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";

import { Box, CssBaseline, ThemeProvider, Typography, IconButton, Drawer, List, ListItem, ListItemText } from "@mui/material";
import { Css, Height, WidthFull } from "@mui/icons-material";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

import LoginPage from "./scenes/auth/login";
import LogoutPage from "./scenes/auth/logout";
import Flowus from "./scenes/flowus/App";
import SetFlow from "./scenes/setflow/App"
import Sidebar from "./scenes/global/Sidebar";
import Dashboard from "./scenes/dashboard";
import Team from "./scenes/team";
import Invoices from "./scenes/invoices";
import Contacts from "./scenes/contacts";
import Bar from "./scenes/bar";
import Form from "./scenes/form";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import FAQ from "./scenes/faq";
import Geography from "./scenes/geography";
import Calendar from "./scenes/calendar/calendar";

import ProfilePage from "./scenes/auth/profile";
import DejavuBidask from "./scenes/dejavubidask/index";

import DejavuBidaskOld2 from "./scenes/dejavubidask/indexold";
import DejavuBidask2 from "./scenes/dejavubidask/";
import DejavuBidaskUSA from "./scenes/dejavubidask_usa";
import DejavuBidaskOld2V4 from "./scenes/dejavubidask/BidaskV4";

import DejavuTickmatch from "./scenes/dejavutickmatch";
import DejavuTickmatch2 from "./scenes/dejavutickmatch/index2";
import TickMatch from "./scenes/dejavutickmatch/indexv4";
import DejavuTickmatch_v4 from "./scenes/dejavutickmatch/tickmatch_v4";
import Chatbot from "./scenes/chatbot";
import Realtime from "./scenes/realtime/realtime";
import Realtime_v4 from "./scenes/realtime/realtime_v4";
import RankBoard from './scenes/valueoftime/pages/rankboard'
import TopRank from './scenes/valueoftime/pages/toprank'
import Petroleum from "./scenes/petroleum/index_backup";
import PetroleumComponent from "./scenes/petroleum/index";
import PetroleumComponentZero from "./scenes/petroleum/indexzero";
// import PetroleumComponent from "./scenes/test_petroleum/index";
import PetroleumComponent_v4 from "./scenes/test_petroleum/petrov4";
import UsersComponent from "./scenes/users";
import RolesComponent from "./scenes/roles";
import ThaiRubberChartComponent from "./scenes/rubber";
import ThaiRubberChartComponentNewUI from "./scenes/rubber/indexnewui";
import ThaiRubberChartComponentNewUI2 from "./scenes/rubber/indexnewui2";
import BrokerrankingComponent from "./scenes/brokerranking/brokerranking"
import LastedBrokerrankingComponent from "./scenes/brokerranking/newBrokerranking"
import Gold from './scenes/gold/gold'
import FiveChart_v4 from './scenes/gold/gold_v4'
import Money_in_out from './scenes/money_in_out/index'
import Volumeprofile from "./scenes/volumeprofile/vp";
import MoneyInOutStock from './scenes/moneyinoutstock/index'
import Hotstock from './scenes/hotstock/index'
// import MoneyInOut from './scenes/money_in_out/Money_in_out'
import FullscreenPageMoneyinout from './scenes/money_in_out/FullscreenPage'
import Realflow from './scenes/realflow/index'
import FullscreenPageRealflow from './scenes/realflow/FullscreenPage'
import Hisflow from './scenes/histflow/index'
import FullscreenPageHisflow from './scenes/histflow/FullscreenPage'
import FlipPage from './scenes/Flip/Flip';
import FullscreenPageFlip from './scenes/Flip/FullscreenPageFlip';
// C:\project\rest_api\client\src\scenes\Flip\FullscreenPageFlip.jsx
import YTDPage from './scenes/YTD';
// C:\project\rest_api\client\src\scenes\Outshort\app.js
import Outshort from './scenes/Outshort/app';
import S50 from './scenes/s50';
import S50Page_v4 from './scenes/s50/s50_v4';
// import StrategyOptionPage from './scenes/optionstrategy/pages/strategyOptionPage'
// src\scenes\testsh\app.js

import S50_outshort from './scenes/s50_outshort/app';
import ShareholderLookup from './scenes/testsh/app';
import Fund from './scenes/fund/Fund';
import ValueOfTime from './scenes/vot/ValueOfTime';
import DW from './scenes/dw/DW';
import Flow from './scenes/flow/index'
import Multibidask from './scenes/multibidask/index'
import Options from './scenes/options/index'
import Index from './scenes/index/index'
import Daytrade from './scenes/daytrade/index';
import News from './scenes/news/news'
import AcceptNewsComponent from "./scenes/news/accept_news";
import DeclineNewsComponent from "./scenes/news/decline_news";
import LinkNewsComponent from "./scenes/news/link_news";

import Error401Page from "./scenes/error/401";
import Error403Page from "./scenes/error/403";
import UpgradePlanPage from "./scenes/error/upgrade_plan";


import DashboardHis from "./scenes/hismoneyinout/DashboardHis";
import DashboardSetIn from "./scenes/hismoneyinout/pre-chart/DashboardSetIn"
import DashboardSetOut from "./scenes/hismoneyinout/pre-chart/DashboardSetOut"
import DashboardNonIn from "./scenes/hismoneyinout/pre-chart/DashboardNonIn"
import DashboardNonOut from "./scenes/hismoneyinout/pre-chart/DashboardNonOut"
import DashboardMaiIn from "./scenes/hismoneyinout/pre-chart/DashboardMaiIn"
import DashboardMaiOut from "./scenes/hismoneyinout/pre-chart/DashboardMaiOut"
import DashboardWarrantIn from './scenes/hismoneyinout/pre-chart/DashboardWarrantIn';
import DashboardWarrantOut from './scenes/hismoneyinout/pre-chart/DashboardWarrantOut';
import HisDayTrade from './scenes/hisdaytrade';
import SectorRotation from "./scenes/sectorrotation";
import SectorRotationIntraday from "./scenes/sectorrotation_intraday";
import PageFirst from "./scenes/colab/PageFirst";

import FullChart from "./scenes/fullchart";

import { ColorModeContext, useMode } from "./theme";
import { setCsrfToken, setLogin, setUserDetail, setIpAddress, setLastUrl } from "./state";
import { useFetchingData, __fetchIp__ } from './components/api';
import { useIsMobile } from './components/hooks/'
import DRPage from "./scenes/dr";
import DRPage_v4 from "./scenes/dr/dr_v4";
import MSideBar from "./scenes/global/mobileSidebar";
import SideBarV2 from "./scenes/global/SidebarV2";
import ChatbotPageTest from "./scenes/chatbotlab";
import FullscreenFlowIntraday from "./scenes/realtime/LayoutsChart/fullscreen_flowintraday";
// import AiAgent from "./scenes/aiagent";
import Form2 from "./scenes/auth/login/regis2";
import ChatBotV2Page from "./scenes/chatbotv2";
import OutShortV2 from "./scenes/s50_outshort/outshort";
import Lab1 from "./scenes/lab/lab1";
//import ChatbotV4Page from "./scenes/chatbotv4";
import ChatBotV2PageV2 from "./scenes/chatbotv2/indexworking1";
import FormLogin from './scenes/auth/login/NewForm';
import ManagerBuy from "./scenes/managerbuy/managerbuy";

import FearAndGreed from './scenes/fear_and_greed';

import FreeFloat from './scenes/freefloat/freefloat'

function App() {
  const [theme, colorMode] = useMode();
  const isMobile = useIsMobile();
  const dispatch = useDispatch();
  const { __fetching_data__ } = useFetchingData();

  const [isSidebar, setIsSidebar] = useState(true);

  const isAuth = Boolean(useSelector((state) => state.token != null));
  const userId = useSelector((state) => state.user);
  const userToken = useSelector((state) => state.token);
  const csrfToken = useSelector((state) => state.csrfToken);
  const userDetail = useSelector((state) => state.userDetail);
  const ipAddress = useSelector((state) => state.ipAddress);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const lastUrl = useSelector((state) => state.lastUrl);

  const check_kickoff = async () => {
    const response = await __fetching_data__({ url: `${window.config.base_api_url}/check_kickoff`, method: "POST" });
  }

  const getCSRF = async () => {
    const response = await __fetching_data__({ url: `${window.config.base_api_url}/getCSRF`, method: "GET" });
    dispatch(setCsrfToken({ csrfToken: response.csrfToken }));
  };

  const fetchUser = async () => {
    const userData = await __fetching_data__({ url: `${window.config.base_api_url}/userprofile1/${userId}`, headers: { "Authorization": `Bearer ${userToken}` } });
    if (userData.status) {
      dispatch(setUserDetail({
        Id: userId,
        img_src: userData.data.img_src ? userData.data.img_src : "",
        fullname: (userData.data.firstname ? userData.data.firstname : "") + " " + (userData.data.lastname ? userData.data.lastname : ""),
        firstname: userData.data.firstname ? userData.data.firstname : "",
        lastname: userData.data.lastname ? userData.data.lastname : "",
        email: userData.data.email ? userData.data.email : "",
        app_id: userData.data.app_id ? userData.data.app_id : "",
        user_type: userData.data.user_type ? userData.data.user_type : "",
        permissions: userData.data.permissions ? userData.data.permissions : ""
      }));
    }
  }

  const fetchIp = async () => {
    const IP = await __fetchIp__();
    if (IP.ip) {
      dispatch(setIpAddress({
        ipAddress: IP.ip
      }))
    }
  }

  const handleOnline = () => {
    console.log('Client is online, perform your action here.');
  };

  const updateOnlineStatus = () => {
    const onlineStatus = navigator.onLine;
    if (onlineStatus) {
      handleOnline();
    }
    setIsOnline(onlineStatus);
  };


  useEffect(() => {
    return () => {
      if (csrfToken === null) { getCSRF(); }
    }
  }, [csrfToken]);


  useEffect(() => {
    console.log('IsMobile :', isMobile);

    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    if (!ipAddress) {
      fetchIp();
    }
    if (isAuth) {
      fetchUser();
    }
    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  }, []);

  useEffect(() => {
    if (!Cookies.get("access_token") && !Cookies.get("refresh_token")) {
      // dispatch(setLogin({ user: null, token: null }));
    }
    if (isAuth && (!userDetail.email || userDetail.email == null || userDetail.email == undefined)) {
      fetchUser();
    }
    if (isAuth) {
      check_kickoff();
    }
  }, [isAuth, userDetail, userId]);


  const RouteChangeHandler = () => {
    const location = useLocation();
    useEffect(() => {
      const handleRouteChange = () => {
        const isAuthRoute = !['/login', '/logout'].includes(location.pathname)
        if (isAuth) {
          isAuthRoute && check_kickoff();
          isAuthRoute && !ipAddress && fetchIp();
        }
      };

      return () => {
        handleRouteChange();
      }
    }, [location]);
    return null;
  };

  useEffect(() => {
    // --- ส่วนที่ 1: ขาเข้า (ดักจับ URL จากภายนอก) ---
    const searchParams = new URLSearchParams(window.location.search);
    const externalRedirect = searchParams.get('redirect');

    // เพิ่มเงื่อนไข: ต้องมีค่าใน URL และค่านี้ต้อง "ไม่ตรง" กับที่มีใน Redux อยู่แล้ว
    if (externalRedirect && externalRedirect.startsWith('http') && externalRedirect !== lastUrl) {
      console.log("App.js: Saving new external redirect URL to Redux...");
      dispatch(setLastUrl({ lastUrl: externalRedirect }));
    }

    // --- ส่วนที่ 2: ขาออก (ดีดตัวเมื่อ Login สำเร็จ) ---
    if (isAuth && lastUrl && lastUrl.startsWith('http')) {
      console.log("App.js: User is Auth, redirecting back to:", lastUrl);
      dispatch(setLastUrl({ lastUrl: null }));
      window.location.replace(lastUrl);
    }
  }, [isAuth, lastUrl, dispatch]);

  const Protected = () => {
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const externalRedirect = searchParams.get('redirect');

    if (!isAuth) {
      // const fullUrl = location.pathname + location.search + location.hash;
      // const fullUrl = externalRedirect || (location.pathname + location.search + location.hash);
      // dispatch(setLastUrl({ lastUrl: fullUrl }));
      const currentPath = location.pathname + location.search + location.hash;
      const fullUrl = externalRedirect || currentPath;

      if (fullUrl !== lastUrl) {
        dispatch(setLastUrl({ lastUrl: fullUrl }));
      }
      return <Navigate to="/login" replace />;
    }

    if (lastUrl && lastUrl !== "/" && !lastUrl.startsWith('http') && location.pathname === "/") {
      dispatch(setLastUrl({ lastUrl: null }));
      return <Navigate to={lastUrl} replace />;
    }

    return <Outlet />;
  };

  const protectRoute = (Component, requiredPermission) => {
    if (hasPermission(userDetail.permissions, requiredPermission)) {
      return <Component />;
    } else {
      return <Navigate to="/403" replace />;
    }
  };

  const hasPermission = (permissions, requiredPermission) => {
    if (!permissions || !permissions.permission || !permissions.permission[requiredPermission]) {
      return false;
    }
    const permission = permissions.permission[requiredPermission];
    return permission && permission.read;
  };

  //#######################################################################################
  const [ws, setWs] = useState(null);
  const [message, setMessage] = useState('');
  const [receivedMessage, setReceivedMessage] = useState('');
  const [messageType, setMessageType] = useState('data');

  useEffect(() => {
    console.log("I was here");
    let ws_url;
    ws_url = 'wss://ideatrade1.com:4005/data';
    // ws_url = '/application/data'
    // `ws://${window.location.host}/application`

    const socket = new WebSocket(ws_url);

    socket.onopen = () => {
      console.log('WebSocket connection established 11');
      const message = {
        token: userToken
      };
      socket.send(JSON.stringify(message));
    };

    socket.onmessage = (event) => {
      console.log('Received message:', event.data);
      const parsedMessage = JSON.parse(event.data);
      console.log(parsedMessage)
      switch (parsedMessage.type) {
        case 'echo':
          setReceivedMessage(`Echo: ${parsedMessage.data}`);
          break;
        case 'broadcast':
          setReceivedMessage(`Broadcast: ${parsedMessage.data}`);
          break;
        default:
          setReceivedMessage('Unknown message type');
      }
    };

    socket.onclose = () => {
      console.log("I was here??");
      console.log('WebSocket connection closed');
    };

    setWs(socket);

    return () => {
      socket.close();
    };
  }, []);

  const [openSidebar, setOpenSidebar] = useState(false);
  const toggleSidebar = () => setOpenSidebar(!openSidebar);

  return (
    <BrowserRouter>
      <RouteChangeHandler />
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Box>
            <div className="app">

              {/* {isAuth && !isMobile && <Sidebar isSidebar={isSidebar} />} */}
              {isAuth && !isMobile && <SideBarV2 isSidebar={isSidebar} />}
              <main className="content" id="content">
                <Box>
                  {isMobile && (
                    <MSideBar open={open} toggleSidebar={toggleSidebar} />
                  )}
                  {/* {isAuth && <Topbar setIsSidebar={setIsSidebar} />} */}
                  <Routes>
                    <Route path="/login" element={<FormLogin />} />
                    <Route path="/login2" element={<LoginPage />} />
                    <Route path="/regis2" element={<Form2 />} />
                    <Route path="/logout" element={<LogoutPage />} />
                    <Route path="/401" element={<Error401Page />} />
                    <Route path="/403" element={<Error403Page />} />

                    <Route element={<Protected />} >
                      {/* <Route path="/" element={<Box />} /> */}
                      <Route path="/" element={
                        <Box textAlign="center" mt={5}>
                          <Typography variant="h4" color={'white'}>
                            {isOnline ? 'You are online' : 'You are offline'}
                          </Typography>
                        </Box>
                      } />
                      <Route path="/dashboardp" element={<Dashboard />} />
                      <Route path="/team" element={<Team />} />
                      <Route path="/contacts" element={<Contacts />} />
                      <Route path="/invoices" element={<Invoices />} />
                      <Route path="/form" element={<Form />} />
                      <Route path="/bar" element={<Bar />} />
                      <Route path="/pie" element={<Pie />} />
                      <Route path="/line" element={<Line />} />
                      <Route path="/faq" element={<FAQ />} />
                      <Route path="/calendar" element={<Calendar />} />
                      <Route path="/geography" element={<Geography />} />

                      <Route path="/chatbotbackup" element={<Chatbot />} replace />
                      <Route path="/chatbotv2" element={<ChatBotV2Page />} replace />
                      <Route path="/chatbot" element={<ChatBotV2PageV2 />} replace />
                      <Route path="/petroleum" element={<PetroleumComponent />} />
                      <Route path="/petroleum0" element={<PetroleumComponentZero />} />
                      <Route path="/petroleum_v4" element={<PetroleumComponent_v4 />} />
                      <Route path="/rubber_backup" element={<ThaiRubberChartComponent />} />
                      <Route path="/rubbernewui" element={<ThaiRubberChartComponentNewUI />} />
                      <Route path="/rubber" element={<ThaiRubberChartComponentNewUI2 />} />
                      <Route path="/realtime" element={<Realtime />} />
                      <Route path="/realtime_v4" element={<Realtime_v4 />} />
                      <Route path="/realtime_fullscreen" element={<FullscreenFlowIntraday />} />
                      <Route path="/flowus" element={<Flowus />} />
                      <Route path="/setflow" element={<SetFlow />} />


                      <Route path="/gold" element={<Gold />} />
                      <Route path="/gold_v4" element={<FiveChart_v4 />} />
                      <Route path="/dejavu/bidaskbackup" element={<DejavuBidask />} />
                      <Route path="/dejavu/bidaskaibackup" element={<DejavuBidaskOld2 />} />
                      <Route path="/dejavu/bidask" element={<DejavuBidask2 />} />
                      <Route path="/dejavu/bidask_v4" element={<DejavuBidaskOld2V4 />} />
                      <Route path="/dejavu/bidaskusa" element={<DejavuBidaskUSA />} />
                      <Route path="/dejavu/tickmatch_v4" element={<DejavuTickmatch />} />
                      <Route path="/dejavu/tickmatch2" element={<DejavuTickmatch2 />} />
                      <Route path="/dejavu/tickmatch" element={<TickMatch />} />
                      <Route path="/dejavu/tickmatch_backup" element={<DejavuTickmatch_v4 />} />
                      <Route path="/dr" element={<DRPage />} />
                      <Route path="/dr_v4" element={<DRPage_v4 />} />
                      {/* <Route path="/rankboard" element={<RankBoard />} /> */}
                      {/* <Route path="/toprank" element={<TopRank />} /> */}
                      <Route path="/ideatradepoint" element={<Money_in_out />} />
                      {/* <Route path="/moneyinout" element={<MoneyInOut />} /> */}
                      <Route path="/fullscreenmoneyinout" element={<FullscreenPageMoneyinout />} />

                      <Route path="/moneyinoutstock" element={<MoneyInOutStock />} />
                      <Route path="/hotstock" element={<Hotstock />} />
                      <Route path="/realflow" element={<Realflow />} />
                      <Route path="/fullscreenrealflow" element={<FullscreenPageRealflow />} />
                      <Route path="/fullscreenhisrealflow" element={<FullscreenPageHisflow />} />
                      <Route path="/hisrealflow" element={<Hisflow />} />
                      <Route path="/testsh" element={<ShareholderLookup />} />
                      <Route path="/59_2" element={<ManagerBuy />} />


                      <Route path="/chartflipideatradepoint" element={<FlipPage />} />
                      <Route path="/fullscreenflip" element={<FullscreenPageFlip />} />
                      <Route path="/volumeprofile" element={<Volumeprofile />} />

                      <Route path="/outshortbackup" element={<Outshort />} />
                      <Route path="/hisflow" element={<Flow />} />
                      <Route path="/vot" element={<ValueOfTime />} />
                      <Route path="/dw" element={<DW />} />
                      <Route path="/ytd" element={<YTDPage />} />
                      {/* <Route path="/hisflow" element={<Flow />} /> */}
                      <Route path="/fund" element={<Fund />} />

                      <Route path="/allnews" element={<News />} />
                      <Route path="/acceptnews" element={<AcceptNewsComponent />} />
                      <Route path="/declinenews" element={<DeclineNewsComponent />} />
                      <Route path="/linknews/:title" element={<LinkNewsComponent />} />

                      <Route path="/brokervalue" element={<LastedBrokerrankingComponent />} />
                      <Route path="/brokervalue2" element={<BrokerrankingComponent />} />
                      <Route path="/profile" element={<ProfilePage />} />

                      <Route path="/upgrade" element={<UpgradePlanPage />} />
                      <Route path="/admin/users" element={protectRoute(UsersComponent, 'manageUser')} />
                      <Route path="/admin/roles" element={protectRoute(RolesComponent, 'manageRole')} />

                      <Route path="/Hisideatradepoint" element={<DashboardHis />} />
                      <Route path="/set-in" element={<DashboardSetIn />} />
                      <Route path="/set-out" element={<DashboardSetOut />} />
                      <Route path="/non-in" element={<DashboardNonIn />} />
                      <Route path="/non-out" element={<DashboardNonOut />} />
                      <Route path="/mai-in" element={<DashboardMaiIn />} />
                      <Route path="/mai-out" element={<DashboardMaiOut />} />
                      <Route path="/warrant-in" element={<DashboardWarrantIn />} />
                      <Route path="/warrant-out" element={<DashboardWarrantOut />} />

                      <Route path="/multibidask" element={<Multibidask />} />
                      <Route path="/options" element={<Options />} />
                      <Route path="/indexs" element={<Index />} />
                      <Route path="/daytrade" element={<Daytrade />} />
                      <Route path="/hisdaytrade" element={<HisDayTrade />} />

                      <Route path="/sectorrotation" element={<SectorRotation />} />
                      <Route path="/sectorrotationintraday" element={<SectorRotationIntraday />} />

                      {/* <Route path="/strategyoption" element={<StrategyOptionPage />} /> */}

                      <Route path="/full-chart/:pageType/:market/:sector" element={<FullChart />} />
                      <Route path="/full-chart/:pageType/:market/:sector/:date" element={<FullChart />} />

                      <Route path="/abbidask" element={<PageFirst />} />
                      <Route path="/s50" element={<S50 />} />
                      <Route path="/s50_v4" element={<S50Page_v4 />} />
                      <Route path="/s50_outshort" element={<S50_outshort />} />
                      <Route path="/outshort" element={<OutShortV2 />} />
                      <Route path="/freefloat" element={<FreeFloat />} />
                      <Route path="/test" element={<ChatbotPageTest />} />
                      <Route path="/lab" element={<Lab1 />} />
                      {/* <Route path="/aiagent" element={<AiAgent />} /> */}

                      {/* <Route path='/aiagent' element={() => {
                        // https://d967-147-50-252-213.ngrok-free.app/
                        window.location.href = 'https://example.com/1234';
                        return null;
                      }} /> */}

                      <Route path="/globaltrend" element={<FearAndGreed />} />



                    </Route>
                  </Routes>
                </Box>
              </main>
            </div>
          </Box>
        </ThemeProvider>
      </ColorModeContext.Provider>
    </BrowserRouter >
  );
}

export default App;
